import React from 'react';
import Helmet from 'react-helmet';
import Header from '../components/Header/Header';
import Container from '../components/Container/Container';
import Footer from '../components/Footer/Footer';
import config from '../../config/SiteConfig';

const About = () => (
  <div className="container about-container">
        <Helmet title={`About | ${config.siteTitle}`} />
        <Header>About</Header>
        <Container text>
            <h1>Hello! I’m Ray.</h1>
            <p>
                Welcome to my little space on the internet. I’m a designer, developer, and photographer based in New Zealand.
            </p>
            <p>
                I am a passionate UI/UX designer and front-end developer with an emphasis on usability. I am truly passionate about my work and live and breathe the lifestyle of a die-hard designer/developer.
            </p>
            <p>
                I specialise in front-end development, user interface design, visual design and usability.
            </p>
        </Container>
        <Footer />
  </div>
);

export default About;



// WEBPACK FOOTER //
// ./src/pages/about.jsx